import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Container, Typography, CardContent, Card } from "@mui/material";

const EmailVerified = () => {
  const { loginWithRedirect } = useAuth0();

  useEffect(() => {
    loginWithRedirect();
  }, [loginWithRedirect]);

  return (
    <Container maxWidth="md">
      <Card variant='outlined'>
        <CardContent>
          <Typography variant="h5" style={{marginBottom:"30px"}}>Email Verified!</Typography>
          <Typography variant="body1" style={{marginBottom:"30px"}}>Your email has been successfully verified.</Typography>
          <Typography variant="body1" style={{marginBottom:"30px"}}>Redirecting...</Typography>
        </CardContent>
      </Card>
    </Container>
  );
};

export default EmailVerified;